import ApiService from '@/common/api.service'

import { GET_COMMENTS, PIN_COMMENT, RESET_COMMENT_STATE } from './actions.type'
import {
  SET_COMMENTS,
  SET_ERROR,
  SET_IS_PINNING_COMMENT,
  RESET_STATE
} from './mutations.type'

import Progress from '@/common/progress'

export const getDefaultState = () => {
  return {
    comments: [],
    isPinnigComment: false,
    error: null
  }
}

const state = getDefaultState()

const getters = {
  comments(state) {
    return state.comments
  },
  isPinningComment(state) {
    return state.isPinnigComment
  }
}

const actions = {
  [GET_COMMENTS](context, { id, page }) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/streamings', `${id}/comments?limit=20&page=${page}`)
        .then(({ data }) => {
          context.commit(SET_COMMENTS, data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [PIN_COMMENT](context, { id, comment }) {
    Progress.show()
    context.commit(SET_IS_PINNING_COMMENT, true)
    return new Promise((resolve, reject) => {
      ApiService.post(`socket/api/v1/comments/pinComment`, { streamingId: id, comment: comment })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_IS_PINNING_COMMENT, false)
          resolve(data)
        })
        .catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [RESET_COMMENT_STATE](context) {
    context.commit(RESET_STATE)
  }
}

const mutations = {
  [SET_COMMENTS](state, commentResponse) {
    const comments = commentResponse.data.filter(comment => {
      var duplicated = false
      if (state.comments) {
        state.comments.map(c => {
          if (comment.id === c.id) {
            duplicated = true
          }
        })
      }
      if (!duplicated) {
        return comment.user
      }
    })
    state.comments.unshift(...comments.reverse())
  },
  [SET_IS_PINNING_COMMENT](state, isPinning) {
    state.isPinnigComment = isPinning
  },
  [SET_ERROR](state, error) {
    state.error = error
    state.isPinnigComment = false
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
